import React from 'react';
import PropTypes from 'prop-types';

import PrintButton from './PrintButton';
import CSVButton from './CSVButton';

import './Buttons.css';

const Buttons = props => (
  <div className="Buttons">
    <PrintButton />
    <CSVButton
      header={props.csvHeader}
      data={props.csvData}
      filename={props.filename}
    />
  </div>
);

Buttons.propTypes = {
  csvHeader: PropTypes.array,
  csvData: PropTypes.array,
  filename: PropTypes.string,
};

export default Buttons;



// WEBPACK FOOTER //
// ./src/components/util/Buttons.js